import { useState } from 'react';
import { Card, Button } from 'components';
import { DemoAccountModal } from './Modal';

export const DemoAccountCard = () => {
  const [isModalOpened, setIsModalOpened] = useState(false);
  return (
    <>
      {isModalOpened && <DemoAccountModal onClose={() => setIsModalOpened(false)} />}
      <Card title="Demo account">
        <Button size="large" type="primary" onClick={() => setIsModalOpened(true)}>
          Create new
        </Button>
      </Card>
    </>
  );
};
